'use client';

import { usePathname, useRouter } from 'next/navigation';
import React from 'react';
import SuperTokensReact, { SuperTokensWrapper } from 'supertokens-auth-react';

import { frontendConfig, setRouter } from '@/services/config/frontend';

import { AuthContextProvider } from '../auth-context-provider/auth-context-provider';

if (typeof window !== 'undefined') {
  // we only want to call this init function on the frontend, so we check typeof window !== 'undefined'
  SuperTokensReact.init(frontendConfig());
}

export const SuperTokensProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  setRouter(useRouter(), usePathname() || window.location.pathname);

  return (
    <SuperTokensWrapper>
      <AuthContextProvider>{children}</AuthContextProvider>
    </SuperTokensWrapper>
  );
};
